import { useState } from 'react';
import {
  Button,
  CloseButton,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import api from '@services/api';

type Props = {
  executionId: string;
  handleClose: () => void;
  afterSubmit: () => void;
};

const ConfirmFinishCampaignDialog = ({ executionId, handleClose, afterSubmit }: Props) => {
  const [loading, setLoading] = useState(false);

  const onFinishClick = async () => {
    setLoading(true);

    try {
      const response = await api.delete(`/campaign_execution/${executionId}/finalize`);

      if (response.status === 200) {
        toast.success('Atendimento finalizado com sucesso.');
        afterSubmit();
      } else {
        toast.error('Não foi possível finalizar o atendimento!');
      }
    } catch {
      toast.error('Erro ao finalizar atendimento. Tente novamente!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Tem certeza que deseja finalizar este atendimento?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text color="fg.muted">
                Para encerrar, não pode haver atendimentos em andamento.
                Essa ação é definitiva e não poderá ser desfeita.
                Deseja continuar?
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Button
                variant="outline"
                disabled={loading}
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                bg="green.700"
                color="white"
                onClick={onFinishClick}
                loading={loading}
              >
                Finalizar
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmFinishCampaignDialog;
